
export default defineNuxtPlugin(() => {
  const router = useRouter()
  const route = useRoute()
  const { trackPageView } = useTracking()

  trackPageView({
    isInitial: true,
    path: route.fullPath,
  })

  router.afterEach((to, from) => {
    if (!from?.name || from.path === to.path) {
      return
    }

    setTimeout(
      () => trackPageView({ path: to.fullPath }),
      500
    )
  })
})
